<template>
  <app-modal
    :modal-id="modalId"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">Agregar Renovación</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        enctype="multipart/form-data"
        :data-url="`/accreditations/renew-payments/storeAddPayment`"
      >

      <div class="row col-12 my-2">
          <div class="col-md-6">
              <div class="form-group">
                <label class="mb-0">
                  {{ $t("accreditation_area") }}
                </label>
                
                <app-input
                  id="inputs_accreditation_area_id"
                  type="select"
                  v-model="inputs.accreditation_area_id"
                  :list="accreditationAreaList"
                  v-on:change="onChangeAccreditationArea"
                  :required="true"
                />
              </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
                <label class="mb-0">
                  {{ $t("activity") }}
                </label>
                <app-input
                  id="inputs_acc_activity_id"
                  type="select"
                  v-model="inputs.acc_activity_id"
                  :list="accreditationActivityLists"
                  :required="true"
                />
              </div>
          </div>          
        </div>

        <div class="col-12 alert alert-info" role="alert" v-if="!license_reg">
          <label>
            <strong> Nota: </strong>
          </label>
          <label>Debe tener una licencia registrada para agregar una renovación de licencia.</label>
        </div>

        <div class="col-12 alert alert-info" role="alert" v-if="license_reg">
          <label>
            <strong> Ultima Licencia </strong>
          </label>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="mb-0">
                  {{ $t("Fecha de aprobación") }}
                </label>
                <app-input
                  type="date"
                  v-model="license_reg.approved_date"
                  placeholder=""
                  :disabled="true"
                />
              </div>
          </div>

          <div class="col-md-6">
              <div class="form-group">
                <label class="mb-0">
                  {{ $t("Fecha de caducidad") }}
                </label>
                <app-input
                  type="date"
                  v-model="license_reg.validity_date"
                  placeholder=""
                  :disabled="true"
                />
              </div>
          </div>
          </div>
        </div>

      </form>
    </template>

    <template slot="footer">
      <br>
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>

    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
    mixins: [FormMixin, ModalMixin],
    props: {
    tableId: String,
    accreditationAreaList: Array,
    accreditationActivityList: Array,
  },
    data() {
      return {
        preloader: false,
        loaded: false,
        modalId: "renew-modal-start",
        inputs: {},
        license_reg:{},
        accreditationActivityLists: [{ id: "", value: this.$t("select_option") }],
      }
    },
    watch: {
      "inputs.accreditation_area_id": function () {
        this.accreditationActivityLists= [{ id: "", value: this.$t("select_option") }];
        this.getLicenses();
      },
      "inputs.acc_activity_id": function () {
        this.getLicenses();
      },    
    },
    created() {
      this.getLicenses();
    },
    methods: {
      submit() {
        if (this.license_reg.length == 0) {
          this.$toastr.e("No existe una licencia registrada para poder hacer una renovación de licencia");
          return ;
        }
        if (this.license_reg && !this.license_reg.validity_date) {
          this.$toastr.e("Existe un pago de licencia en proceso");
          return ;
        }
        this.save(this.inputs);

      },
      afterSuccess(response) {
        this.$toastr.s(this.$t("created_success"));
        this.$hub.$emit("reload-" + this.tableId);
      },
      onChangeAccreditationArea() {
        this.accreditationActivityLists = [
          { id: "", value: this.$t("select_option") },
          ...this.accreditationActivityList.filter((item) => {
            return item.parent == this.inputs.accreditation_area_id;
          }),
        ];
      },
      getLicenses() {
        this.axiosGet(
        `/accreditations/renew-payments/registeredLicenses?area_id=${this.inputs.accreditation_area_id}&activity_id=${this.inputs.acc_activity_id}`
      )
      .then((response) => {
        if (response.status == 200) {
          this.license_reg = response.data;
          this.license_reg.approved_date = response.data.approved_date
                ? new Date(response.data.approved_date)
                : null;
          this.license_reg.validity_date = response.data.validity_date
                ? new Date(response.data.validity_date)
                : null;
      
        } 
      })
      .catch((error) => {
          console.log(error);
      });
    },
    }

}
</script>

<style>

</style>